import { render, staticRenderFns } from "./PostnlDeliveryOptions.vue?vue&type=template&id=1c9d02ca"
import script from "./PostnlDeliveryOptions.vue?vue&type=script&lang=ts"
export * from "./PostnlDeliveryOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports